import { Component, OnDestroy, OnInit, Renderer2, } from '@angular/core';
import { BaseComponent } from './Shared/base.component';
import { BrowserDetectService } from './services/browser-detect.service';
import { interval, Subscription, timer } from 'rxjs';
import { GeneralService } from './services/SystemSettings/General.service';
import { AuthService } from './services/auth.service';
import { LotteryService } from './services/Operations/Lottery.service';
import { AutomaticRentRenewalService } from './services/Operations/AutomaticRentRenewal.service';
import { OperationsFunctionID } from './Shared/enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent extends BaseComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(private browserDetectService: BrowserDetectService, private renderer: Renderer2,
    private generalService: GeneralService, private lotteryService: LotteryService,
    private authService: AuthService,
    private arrService: AutomaticRentRenewalService
  ) {
    super();
  }

  ngOnInit() {
    if (this.browserDetectService.isFirefox()) {
      this.renderer.addClass(document.body, 'is-firefox');
    }

    this.subscriptions.push(interval(10 * 60 * 1000).subscribe(() => {
      this.triggerEvent();
    }));

    this.subscriptions.push(
      interval(12 * 60 * 60 * 1000).subscribe(() => {
        this.RandomLottery();
      })
    );

    this.subscriptions.push(timer(0, 60 * 1000).subscribe(() => {
      this.checkARRReminders();
    }));
  }

  triggerEvent() {
    let isLoggedIn: boolean = this.authService.isLoginAutenticated();
    if (isLoggedIn) {
      this.subscriptions.push(this.generalService.deleteAllPastRecordsFromtemp().subscribe(e => {
      }))
    }
  }

  RandomLottery() {
    this.subscriptions.push(this.lotteryService.GenerateRandomLotteryForAllMarket().subscribe(e => {
    }));
  }

  checkARRReminders() {
    if (!this.authService.isLoginAutenticated()) return;

    const arrPermissions = this.generalService.getUserPermissionsForModule(
      OperationsFunctionID['AutomaticRentRenewal']
    );
    if (!arrPermissions?.Functions?.UserGroupRights?.ViewRight) return;

    this.arrService.getARRReminderStatus().subscribe((res: any) => {
      const pending = (res?.Reminders ?? []).filter(
        (r: any) => r.IsInReminderWindow && !r.IsCompleted
      );
      this.arrService.arrPendingReminders$.next(
        pending.map((r: any) => {
          const [hours, minutes] = (r.DeadlineTime as string).split(':').map(Number);
          const deadlineDate = new Date();
          deadlineDate.setHours(hours, minutes, 0, 0);
          const formatted = deadlineDate.toLocaleString('en-US', {
            month: 'long', day: 'numeric', year: 'numeric',
            hour: 'numeric', minute: '2-digit', hour12: true
          });
          return { name: r.RentalTypeName, deadline: formatted };
        })
      );
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
